<template>

        <div class="row g-3">

            <div class="col-3">
                <span>{{ treatment.treatment_at }} </span>
            </div>
            <div class="col-3" v-if="treatment.timezynk_no_show == 1">
                <span><i>Bokat pass som ej använts.</i></span>
            </div>
            <div class="col-3" v-if="displayFrom == 'company' && treatment.timezynk_no_show != 1">
                <span>{{ treatment.employee.name }}</span>
            </div>
            <div class="col-4">
                <span v-if="treatment.treatment_workplace">{{ treatment.treatment_workplace.title }}</span>
                <span v-else>{{ treatment.clinic.card_name_clinic }}</span>
            </div>
            <div class="col-3">
                <span>{{ treatment.clinic.name_person }}</span>
            </div>
            <div class="col-2">
                <span>
                    {{ treatment.contract.subscription.duration.minutes }} min
                </span>
            </div>
            <div class="col-3" v-if="treatment.timezynk_no_show == 1"></div>
            <div class="col-3" v-else>
                <span v-if="treatment.employee_part_payment_type === 'none'">
                    Nej
                </span>
                <span v-if="treatment.employee_part_payment_type === 'salary'">
                    {{ treatment.employee_part_payment_amount }} kr från lön
                </span>
                <span v-if="treatment.employee_part_payment_type === 'allowance'">
                    {{ treatment.employee_part_payment_amount }} kr från friskvård
                </span>
            </div>
            <div class="col-3">
                <span v-if="treatment.admin">
                    {{ treatment.admin.name }}
                </span>
                <span v-if="!treatment.admin && !treatment.timezynk_vid">
                    Massören
                </span>
            </div>
            <div class="col-2">
                <span>{{ treatment.created_at }}</span>
            </div>

            <div class="d-flex justify-content-end" :class="{ 'col-4' : displayFrom == 'employee', 'col-1' : displayFrom == 'company' }">
                <button class="btn btn-danger btn-sm" @click="triggerDelete()" v-if="treatment.is_deletable">
                    <img src="/images/admin/icon-trash.svg">
                    <div class="tooltip-label">Ta bort registreringen. Du kan ta bort en registrering fram till
                        sista dagen i samma månad.
                    </div>
                </button>
                <button class="btn btn-danger btn-sm inactive" v-else>
                    <img src="/images/admin/icon-trash.svg">
                    <div class="tooltip-label">Registreringen kan inte längre tas bort.
                    </div>
                </button>
            </div>

        </div>

</template>

<script>
import moment from 'moment'

import deleter from '../../../../shared/mixins/deleter'

export default {

    mixins: [
        deleter
    ],

    props: {
        treatment: {
            required: true
        },
        displayFrom: {
            default: 'employee' // employee || company
        }
    },

    computed: {
        deleterUrl () {
            return '/employees/' + this.treatment.employee_id + '/treatments/' + this.treatment.id
        }
    },

    methods: {
        refresh () {
            this.$emit('refresh')
        },

        triggerDelete () {
            if (!confirm('Är du säker')) {
                return
            }
            this.deleterDelete()
        },

        deleterSuccess (data) {
            bus.$emit(
                'notify',
                'Borttaget'
            )
            this.$emit('refresh')
        }
    }

}
</script>
